<template>
	<div class="flex items-center justify-center w-full pb-4">
		<div class="relative w-full h-3 overflow-hidden rounded-full progress-bar-track bg-mx-gray-50 dark:bg-mx-green-600">
			<div
				class="progress-bar absolute top-0 left-0 h-full transition-all rounded-full duration-[50ms] ease-in-out"
				:style="{ width: `${progress}%` }"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	/** Progress percentage (0-100) */
	progress: number
}>()
</script>

<style scoped>
.dark .progress-bar-track {
	box-shadow:
	4px 4px 8px hsla(193, 28%, 13%, 0.3),
	-4px -4px 8px hsla(193, 23%, 36%, 0.2),
		inset 2px 1px 8px rgba(0, 0, 0, 0.05),
		inset 2px 2px 4px rgba(5, 5, 5, 0.4),
    inset -2px -2px 4px hsla(193, 23%, 36%, 0.315);
}
.dark .progress-bar {
	@apply bg-mx-gray-300;
	box-shadow: rgba(0, 0, 0, 0.17) 0px -6px 4px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -6px 5px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -8px 6px 0px inset;
}

.progress-bar-track {
  box-shadow:
    4px 4px 8px rgba(0, 0, 0, 0.1),
    -4px -4px 8px rgba(255, 255, 255, 0.8),
		inset 2px 1px 8px rgba(0, 0, 0, 0.05),
    inset 2px 2px 4px rgba(0, 0, 0, 0.1),
    inset -2px -2px 4px rgba(255, 255, 255, 0.8);
}
.progress-bar {
	@apply bg-mx-gray-200;
	box-shadow: rgba(0, 0, 0, 0.17) 0px -6px 4px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -6px 5px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -8px 6px 0px inset;
}
</style>
